import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const [params] = useSearchParams();
  const error = params.get("error");

  useEffect(() => {
    if (error) toast.error(error);
  }, [error]);

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="login-page">
      <div
        className="hidden lg:block relative grid-bg"
        style={{
          backgroundImage:
            "linear-gradient(rgba(250,250,250,0.7), rgba(250,250,250,0.7)), url('https://images.unsplash.com/photo-1618044733300-9472054094ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhY2NvdW50aW5nJTIwZmluYW5jZSUyMHBhcGVyd29yayUyMGFic3RyYWN0fGVufDB8fHx8MTc4MDQ4MDk1NXww&ixlib=rb-4.1.0&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute bottom-12 left-12 right-12">
          <p className="label-eyebrow mb-3">Convivium / fact</p>
          <h2 className="font-heading text-4xl tracking-tight max-w-md">
            Control de facturación para tu red de restaurantes.
          </h2>
          <p className="mt-4 text-sm text-zinc-700 max-w-sm">
            Eventos, aforos, anticipos y restantes — un solo panel para que no
            se te escape un solo cobro.
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 lg:p-16 bg-white">
        <div className="w-full max-w-sm">
          <p className="label-eyebrow">Acceso restringido</p>
          <h1 className="font-heading text-4xl tracking-tight mt-3">Inicia sesión</h1>
          <p className="text-sm text-zinc-600 mt-3 leading-relaxed">
            Solo cuentas autorizadas pueden entrar. Si necesitas acceso, pide
            al administrador que añada tu correo a la lista.
          </p>
          <button
            data-testid="google-login-button"
            onClick={handleLogin}
            className="w-full mt-8 bg-zinc-900 text-white py-3 px-4 text-sm font-medium hover:bg-zinc-800 transition-colors duration-200 flex items-center justify-center gap-3"
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z"/>
            </svg>
            Continuar con Google
          </button>
          <div className="mt-10 pt-6 border-t border-zinc-200">
            <p className="label-eyebrow">Cómo funciona</p>
            <ul className="mt-3 space-y-2 text-xs text-zinc-600">
              <li>1. El admin añade tu email a la allowlist.</li>
              <li>2. Inicia sesión con tu cuenta de Google.</li>
              <li>3. Accede al panel según tu rol.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
